import { render, staticRenderFns } from "./FavouriteProductsSectionContainer.vue?vue&type=template&id=7c0b38d4&lang=html&"
import script from "./FavouriteProductsSectionContainer.vue?vue&type=script&lang=ts&"
export * from "./FavouriteProductsSectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports